/**
 * @Author 金一泽
 * @Description faq请求方法
 */
import request from "@/api/http/request";
import { ADD_CONTACTUS } from "@/api/apiConst/contactUs";


// faq字段 
export interface contactUsFormType {
    name?: string;
    company?: string;
    salesName?: string;
    email?: string;
    mobile?: string;
    industry?: string;
    question?: string;
}


export function addContactUs(data:contactUsFormType) {
    return request.post(ADD_CONTACTUS,data);
}


